import React from 'react';
import { Loader as ZenitLoader } from '@uberall/zenit';

import styles from './loader.module.css';

interface CustomLoaderProps {
    ariaLabel?: string;
}

const Loader: React.FC<CustomLoaderProps> = ({ ariaLabel = 'loading' }) => {
    return (
        <span aria-label={ariaLabel} data-testid="survey-loader">
            <ZenitLoader className={styles.container} />
        </span>
    );
};

export default Loader;
